// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ----------------- Nur für Beschwerdemanagement RD ECK ---------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------

import {
	SET_NEW_ISSUE_DRAWER_STATE,
	SET_NEW_ISSUE_PROP_VALUE,
	RESET_NEW_ISSUE_FORM,
	SERVER_SEND_NEW_ISSUE,
	SIGNOUT_USER,
	SHOW_NEW_ISSUE_FEEDBACK,
	CREATE_NEW_ISSUE_SUCCESS,
	CREATE_NEW_ISSUE_ERROR
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	newIssue: {
		typeId: 0,
		supTypeId: 0,
		description: '',
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		zip: '',
		city: '',
		street: '',
		houseNumber: '',
		responseType: 1,
		title: '',
		responsibleId: '',
		userComment: '',
		attachements: []
	},
	showDrawer: false,
	showFeedback: false,
	loading: {
		sendNewIssue: false
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_NEW_ISSUE_DRAWER_STATE:
			return {
				...state,
				showDrawer: action.payload
			};
		case SET_NEW_ISSUE_PROP_VALUE:
			return {
				...state,
				newIssue: {
					...state.newIssue,
					...action.payload
				}
			};
		case RESET_NEW_ISSUE_FORM:
			return {
				...INITIAL_STATE,
				newIssue: INITIAL_STATE.newIssue,
				showDrawer: state.showDrawer
			};
		case SERVER_SEND_NEW_ISSUE:
			return {
				...state,
				showFeedback: false,
				feedBackResponsible: '',
				loading: {
					...state.loading,
					sendNewIssue: true
				}
			};
		case CREATE_NEW_ISSUE_SUCCESS:
		case CREATE_NEW_ISSUE_ERROR:
			return { ...state, loading: { ...state.loading, sendNewReport: false } };
		case SHOW_NEW_ISSUE_FEEDBACK:
			return {
				...INITIAL_STATE,
				newIssue: INITIAL_STATE.newIssue,
				showFeedback: true,
				feedBackResponsible: action.payload.organisationResponsibleName || action.payload.organisationName
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/NewIssue.js